import { useState, useEffect } from 'react';
import { checkActiveSubscription } from '../services/subscriptionService/subscriptionService';

import { logger } from "utils/logger";
export const useSubscription = (tariffId?: number) => {
    const [hasActiveSubscription, setHasActiveSubscription] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        const checkSubscription = async () => {
            try {
                const hasSubscription = await checkActiveSubscription(tariffId);
                setHasActiveSubscription(hasSubscription);
            } catch (error) {
                logger.error('Ошибка при проверке подписки:', error);
                setHasActiveSubscription(false);
            } finally {
                setIsLoading(false);
            }
        };

        checkSubscription();
    }, [tariffId]);

    return { hasActiveSubscription, isLoading };
}; 